import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';

import { type ReportActionRow } from '@/domain/results/types';
import { formatCount } from '@/domain/results/utils';
import { useTranslate } from '@/state/i18n';
import { radiusTokens } from '@/theme/themePrimitives';

interface Props {
  rows: ReportActionRow[];
}

/** "Cliques por botão": clicks and people per button kind; under 20 people shows no number. */
const ReportActionsTable = ({ rows }: Props) => {
  const t = useTranslate('domain.results.components.ReportActionsTable');

  return (
    <Paper variant="outlined" sx={sx.paper}>
      <Typography variant="subtitle2" fontWeight={700} sx={{ px: 2.5, pt: 2.5 }}>
        {t('title')}
      </Typography>
      {rows.length ? (
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>{t('action')}</TableCell>
              <TableCell align="right">{t('clicks')}</TableCell>
              <TableCell align="right">{t('people')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.key}>
                <TableCell>{row.label}</TableCell>
                {row.hidden ? (
                  <TableCell colSpan={2} align="right">
                    <Typography variant="caption" color="text.secondary">
                      {t('hidden')}
                    </Typography>
                  </TableCell>
                ) : (
                  <>
                    <TableCell align="right">{formatCount(row.clicks)}</TableCell>
                    <TableCell align="right">{formatCount(row.people)}</TableCell>
                  </>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      ) : (
        <Typography variant="body2" color="text.secondary" sx={{ p: 2.5 }}>
          {t('empty')}
        </Typography>
      )}
    </Paper>
  );
};

export default ReportActionsTable;

const sx = {
  paper: { borderRadius: radiusTokens.xxl, overflow: 'hidden' },
};
